// import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Form, Button } from "antd";
import { FormBox, InputBox } from "../../../components/AntdAddons";
import useStore from "../../../store";
import BannerImage from "../../../assets/images/banner-img-02.jpg";
import { EbookRequest } from "../../../requests/PagesRequest";
import SVGSprite from "../../../assets/images/icon/eBook-sprite.svg";
import LogoutModal from "./element/LogoutModal";

// import { ReactComponent as PaymentIcon } from "../../../assets/images/icon/payment-icon.svg";
// import { ReactComponent as DeliveryIcon } from "../../../assets/images/icon/delivery-icon.svg";
// import { ReactComponent as LocationIcon } from "../../../assets/images/icon/location-icon.svg";
// import { ReactComponent as QuickIcon } from "../../../assets/images/icon/quick-icon.svg";
import SeoHeader from "../../../components/SeoHeader";
import { ErrorProps } from "../../../store/RootStore/RootInterface";

const ShipNow: React.FC = observer(() => {
  const [form] = Form.useForm();
  const { EBOOKSTORE, AUTH } = useStore();
  const {
    ebookPickupPincodeCheck,
    ebookDeliveryPincodeCheck,
    ebook_pickup_pincode_data,
    ebook_delivery_pincode_data,
    getEbookingFormData,
    ebooking_form_data,
  } = EBOOKSTORE;

  const pageData =
    ebooking_form_data && ebooking_form_data?.sections?.page_content;

  const navigate = useNavigate();
  const { token, setToken } = AUTH;

  const [disabledPickup, setDisabledPickup] = useState<boolean>(true);
  const [disabledDelivery, setDisabledDelivery] = useState<boolean>(true);
  const [pickupCity, setPickupCity] = useState<any>(null);
  const [deliveryCity, setDeliveryCity] = useState<any>(null);
  const [showPickCity, setShowPickCity] = useState<boolean>(false);
  const [showDelCity, setShowDelCity] = useState<boolean>(false);
  // const [desinationPage, setDesinationPage] = useState<string>("");

  const handleSubmit = (data: any) => {
    if (ebook_pickup_pincode_data) {
      localStorage.setItem(
        "ebook_pickup_pin",
        JSON.stringify(ebook_pickup_pincode_data)
      );
    } else {
      localStorage.setItem(
        "ebook_pickup_pin",
        localStorage.getItem("ebook_pickup_pin") ?? ""
      );
    }

    if (ebook_delivery_pincode_data) {
      localStorage.setItem(
        "ebook_delivery_pin",
        JSON.stringify(ebook_delivery_pincode_data)
      );
    } else {
      localStorage.setItem(
        "ebook_delivery_pin",
        localStorage.getItem("ebook_delivery_pin") ?? ""
      );
    }

    if (token) {
      navigate("/ebooking-form");
    } else {
      navigate("/ebook-login");
    }

    // if (desinationPage === "ebooking") {
    // 	if (ebook_pickup_pincode_data) {
    // 		localStorage.setItem("ebook_pickup_pin", JSON.stringify(ebook_pickup_pincode_data));
    // 	} else {
    // 		localStorage.setItem("ebook_pickup_pin", localStorage.getItem("ebook_pickup_pin") ?? "");
    // 	}

    // 	if (ebook_delivery_pincode_data) {
    // 		localStorage.setItem("ebook_delivery_pin", JSON.stringify(ebook_delivery_pincode_data));
    // 	} else {
    // 		localStorage.setItem("ebook_delivery_pin", localStorage.getItem("ebook_delivery_pin") ?? "");
    // 	}

    // 	if (token) {
    // 		navigate("/e-booking");
    // 	} else {
    // 		navigate("/ebook-login");
    // 	}
    // } else {
    // 	if (travelfree_pickup_pincode_data) {
    // 		localStorage.setItem("travelfree_pickup_pin", JSON.stringify(travelfree_pickup_pincode_data));
    // 	} else {
    // 		localStorage.setItem("travelfree_pickup_pin", localStorage.getItem("travelfree_pickup_pin") ?? "");
    // 	}

    // 	if (travelfree_delivery_pincode_data) {
    // 		localStorage.setItem("travelfree_delivery_pin", JSON.stringify(travelfree_delivery_pincode_data));
    // 	} else {
    // 		localStorage.setItem("travelfree_delivery_pin", localStorage.getItem("travelfree_delivery_pin") ?? "");
    // 	}

    // }

    // if (token) {
    // 	desinationPage === "ebooking" ? navigate("/e-booking") : desinationPage === "travelfree" ? navigate("/travelfree") : navigate("/e-booking");
    // } else {
    // 	navigate("/ebook-login");
    // }
  };

  const checkPickupPincode = () => {
    const payload = {
      pincode_type: 1,
      pickup_pincode: form.getFieldValue("pickup_pincode"),
    };

    setDisabledPickup(true);
    if (form.getFieldValue("pickup_pincode").trim().length >= 6) {
      ebookPickupPincodeCheck(payload)
        .then(() => {
          setDisabledPickup(false);
          setShowPickCity(true);
        })
        .catch((e: ErrorProps) => {
          form.setFields(e?.data?.errors);
          AUTH.assignErrorToInput(form, e?.data?.errors);
          setDisabledPickup(true);
          setShowPickCity(false);
        });
      // if (desinationPage === "ebooking") {
      // 	ebookPickupPincodeCheck(payload).then(() => {
      // 		setDisabledPickup(false);
      // 	});
      // } else {
      // 	travelfreePickupPincodeCheck(payload).then(() => {
      // 		setDisabledPickup(false);
      // 	});
      // }
    }
  };

  const checkDeliveryPincode = () => {
    const payload = {
      pincode_type: 2,
      pickup_pincode: form.getFieldValue("pickup_pincode"),
      delivery_pincode: form.getFieldValue("delivery_pincode"),
    };

    setDisabledDelivery(true);
    if (form.getFieldValue("delivery_pincode").trim().length >= 6) {
      ebookDeliveryPincodeCheck(payload)
        .then(() => {
          setDisabledDelivery(false);
          setShowDelCity(true);
        })
        .catch((e: ErrorProps) => {
          form.setFields(e?.data?.errors);
          AUTH.assignErrorToInput(form, e?.data?.errors);
          setDisabledPickup(true);
          setShowDelCity(false);
        });

      // if (desinationPage === "ebooking") {
      // 	ebookDeliveryPincodeCheck(payload).then(() => {
      // 		setDisabledDelivery(false);
      // 	});
      // } else {
      // 	travelfreeDeliveryPincodeCheck(payload).then(() => {
      // 		setDisabledDelivery(false);
      // 	});
      // });
    }
  };

  useEffect(() => {
    const pickupData: any = localStorage.getItem("ebook_pickup_pin");
    const deliveryData: any = localStorage.getItem("ebook_delivery_pin");
    const getToken: any = localStorage.getItem("token");
    // const getDesinationPage: any = localStorage.getItem("desinationPage");
    // setDesinationPage(getDesinationPage);
    localStorage.setItem("desinationPage", "ebooking");
    setPickupCity(JSON.parse(pickupData));
    setDeliveryCity(JSON.parse(deliveryData));
    if (getToken) {
      setToken(getToken);
    } else {
      setToken(null);
    }

    form.setFieldsValue({
      pickup_pincode: JSON.parse(pickupData)?.pincode,
      delivery_pincode: JSON.parse(deliveryData)?.pincode,
    });

    if (pickupData) {
      setShowPickCity(true);
    }
    if (deliveryData) {
      setShowDelCity(true);
    }
    if (pickupData && deliveryData) {
      setDisabledDelivery(false);
      setDisabledPickup(false);
    }
  }, [form, token, setToken]);

  useEffect(() => {
    getEbookingFormData();
  }, [getEbookingFormData]);

  const SeoData = {
    title: ebooking_form_data?.seo_data?.title,
    description: ebooking_form_data?.seo_data?.description,
    keywords: ebooking_form_data?.seo_data?.keywords,
    url: ebooking_form_data?.seo_data?.url,
    ogTitle: ebooking_form_data?.seo_data?.og_title,
    ogImage: ebooking_form_data?.seo_data?.og_image,
  };

  return (
    <>
      <SeoHeader seoData={SeoData} />
      <section className="login_section eBook_login header_size_mt pv-64 bg_img">
        <span
          className="bannerImg"
          style={{ backgroundImage: `url(${BannerImage})` }}
        ></span>
        <div className="container">
          <div className="sc_title text-center">
            <div className="main_title" data-title={"E-Booking"}>
              <h3>E-Booking</h3>
            </div>
          </div>
          <div className="title_box">
            <h3>
              {pageData?.heading_1 ??
                "We deliver Pan India. Send from your location, to anywhere in the country. Delivering Innovation"}
              <strong>
                {pageData?.heading_2 ??
                  "Delivering to the nation from Shree Maruti to you"}
              </strong>
            </h3>
          </div>

          <div className="card_wrap pincode max-1420">
            <div className="card_title">
              <Link to="/ebook-login">Login / Register</Link>
            </div>
            <Row gutter={0}>
              <Col xs={{ span: 24 }} md={{ span: 12 }} className="col_img">
                <div className="col_wrap">
                  <br />
                  <h3>
                    {pageData?.heading_3 ??
                      "Get a pickup from the comfort of your home."}
                  </h3>
                  <ul className="pointList">
                    {pageData?.list?.map((item: any, index: number) => {
                      return (
                        <li key={index}>
                          {item?.icon !== "" ? (
                            <img src={item?.icon} alt="" />
                          ) : (
                            <svg className="rightTic">
                              <use xlinkHref={`${SVGSprite}#right-tic`}></use>
                            </svg>
                          )}
                          {item?.title}
                        </li>
                      );
                    })}
                    {/* <li>
                      <PaymentIcon /> Way to go with Multiple Payment Options
                    </li>
                    <li>
                      <LocationIcon /> Flexibility of Real Time Tracking
                    </li>
                    <li>
                      <DeliveryIcon /> Hassle-Free Pickup and Delivery
                    </li>
                    <li>
                      <QuickIcon /> Reliable, Safer, Faster Delivery
                    </li> */}
                  </ul>
                </div>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }} className="col_form">
                <div className="col_wrap">
                  <h3>Enter location details</h3>
                  <FormBox
                    form={form}
                    id="careerForm"
                    className="location_form"
                    onFinish={handleSubmit}
                    // onChange={handleChange}
                  >
                    <div className="input_group">
                      <InputBox.Text
                        // label="Name"
                        placeholder="Pickup area pincode"
                        name="pickup_pincode"
                        maxLength={6}
                        onChange={(e) => {
                          if (e.target.value.length === 6) {
                            checkPickupPincode();
                          } else {
                            // checkPickupPincode();
                            setShowPickCity(false);
                          }
                        }}
                        rules={EbookRequest.pickup_pincode}
                      />
                      <span className="citySuffix">
                        {showPickCity === true
                          ? ebook_pickup_pincode_data?.city_pick
                            ? ebook_pickup_pincode_data.city_pick
                            : pickupCity?.city_pick
                          : null}
                      </span>
                    </div>
                    <div className="input_group">
                      <InputBox.Text
                        // label="Name"
                        placeholder="Delivery area pincode"
                        name="delivery_pincode"
                        maxLength={6}
                        onChange={(e) => {
                          if (e.target.value.length === 6) {
                            checkDeliveryPincode();
                          } else {
                            // checkDeliveryPincode();
                            setShowDelCity(false);
                          }
                        }}
                        rules={EbookRequest.delivery_pincode}
                      />
                      <span className="citySuffix">
                        {showDelCity === true
                          ? ebook_delivery_pincode_data
                            ? ebook_delivery_pincode_data.city
                            : deliveryCity?.city
                          : null}
                      </span>
                      {/* {desinationPage === "ebooking" ? <span className="citySuffix">{showDelCity && ebook_delivery_pincode_data ? ebook_delivery_pincode_data.city : deliveryCity?.city}</span> : <span className="citySuffix">{showDelCity && travelfree_delivery_pincode_data ? travelfree_delivery_pincode_data.city : deliveryCity?.city}</span>} */}
                    </div>
                    {/* <div className="input_group">
                      <p> Get a free pickup from the comfort of your home </p>
                    </div> */}
                    <div className="input_group">
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={disabledPickup || disabledDelivery}
                        // loading={saving}
                      >
                        Ship Now
                      </Button>
                    </div>
                  </FormBox>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>

      <LogoutModal />
    </>
  );
});

export default ShipNow;
